<div class="white-container">
  <abp-page>

    <div class="card">
      <div class="card-body">

        <div class="mb-5" *abpPermission="BothPermissions">
          <div *abpPermission="NotificationsPermission">
            @if (!isLoading().enableNotification) {
              <div class="d-flex justify-content-between mb-3">
                <div class="d-flex gap-3 align-items-center">
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      id="enableNotification"
                      [checked]="enableNotification()"
                      (change)="changeNotification($event)"
                      type="checkbox"
                      role="switch"
                      />
                  </div>
                  <label for="enableNotification">{{'::AccountSettings:EnableNotification' | abpLocalization}}</label>
                </div>
                <button class="btn btn-primary" (click)="saveNotification()">{{'::Save' | abpLocalization }}</button>
              </div>
            } @else {
              <div class="d-flex justify-content-between mb-3">
                <div class="shimmer-item">
                  <div class="shimmer"></div>
                </div>
                <div class="shimmer-item shimmer-button">
                  <div class="shimmer"></div>
                </div>
              </div>
            }

          </div>

          <div *abpPermission="AIDetectionPermission">
            @if (!isLoading().enableAI) {
              <div class="d-flex justify-content-between">
                <div class="d-flex gap-3 align-items-center">
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      id="enableNotification"
                      (change)="changeAIDetection($event)"
                      [checked]="enableAI()"
                      type="checkbox"
                      role="switch"
                      />
                  </div>
                  <label for="enableNotification">{{'::AccountSettings:EnableAI' | abpLocalization}}</label>
                </div>
                <button class="btn btn-primary" (click)="saveAI()">{{'::Save' | abpLocalization }}</button>
              </div>
            } @else {
              <div class="d-flex justify-content-between mb-3">
                <div class="shimmer-item">
                  <div class="shimmer"></div>
                </div>
                <div class="shimmer-item shimmer-button">
                  <div class="shimmer"></div>
                </div>
              </div>
            }

          </div>
        </div>

        <div class="col-sm d-flex align-items-center mb-3">
          <h1 class="content-header-title my-0">{{ '::DeleteMyAccountTitle' | abpLocalization }}</h1>
        </div>
        <button class="btn btn-danger" (click)="deleteMyAccount()">{{'::DeleteMyAccount' | abpLocalization }}</button>
      </div>
    </div>
  </abp-page>
</div>
